export default __webpack_public_path__ + "static/media/vertical.b90d9b3a.jpeg";